import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import { getCategoryLabel } from "src/helpers/helpers";
import { InventoryType } from "./inventory-types";

const useInventoryTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Product Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Category",
      accessor: "category",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<InventoryType>) => {
        const label = getCategoryLabel(value);
        return <TextCell value={label} />;
      },
    },
    {
      Header: "Quantity",
      accessor: "quantity",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   className: "min-w-[150px]",
    //   Cell: ({ row: { original } }: CellProps<InventoryType>) => {
    //     const label = getStatus(original.status);
    //     return <Status label={label} />;
    //   },
    // },
    // {
    //   Header: "Actions",
    //   accessor: "id",
    //   className: "min-w-[200px]",
    //   Cell: ({ value }: CellProps<InventoryType>) => (
    //     <ActionsCell value={value} onDelete={() => onDelete(value)} />
    //   ),
    // },
  ];
};

export default useInventoryTableColumns;
